import styled from 'styled-components'

export const Wrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 5fr);
  gap: ${props => props.theme.spacing.default} ${props => props.theme.spacing.large};
  grid-template-areas: '. . . .';
  justify-content: center;
  align-content: center;
  justify-items: start;
  align-items: center;
  padding: ${props => props.theme.spacing.medium} 0;
`

export const FilterItem = styled.span<{ selected?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  background-color: ${props => (props.selected ? `#EEEEFF ` : props.theme.colors.white[500])};
  padding: 20px 20px;
  width: 100%;
  border: 1px solid #c1bcca;
  border-radius: 8px;
  font-weight: 500;

  & > div:first-child {
    margin-right: ${props => props.theme.spacing.default};
  }

  &:hover {
    background-color: #eeeeff;
    cursor: pointer;
  }
`
